<mat-card appearance="outlined" class="cardForm">
  <mat-card-header>
    <mat-card-title class="cardTitle">
      <h1>{{ "recurringOrders.create.title" | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-progress-bar
      *ngIf="isLoading"
      class="progress-bar"
      mode="indeterminate"
      color="accent"
    >
    </mat-progress-bar>

    <form
      [formGroup]="clientForm"
      *ngIf="!isAdminWithOneClient && !isLoading"
      class="formClient"
    >
    <section>
        <h3>
          Agence <span class="red">*</span>
        </h3>

        <app-autocomplete
          [control]="getClientControl('client')"
          [list]="clients"
          label="users.edit.clients.select.label"
        >
        </app-autocomplete>
      </section>
    </form>

    <form
      class="edit-form"
      [formGroup]="editForm"
      (submit)="onSubmit()"
      *ngIf="editForm && canChooseValue"
    >
      <section style="padding: 20px 0px">
        <mat-slide-toggle formControlName="isPonctual" color="primary">
          Commande ponctuelle
        </mat-slide-toggle>
      </section>

      <fieldset *ngIf="!isPonctualOrder">
        <legend>Fréquence</legend>

        <mat-form-field class="creation-time-field">
          <mat-label>Heure de création</mat-label>
          <input
            id="inputTime"
            matInput
            type="time"
            matInput
            formControlName="creationTime"
          />
        </mat-form-field>

        <mat-form-field class="start-time-field">
          <mat-label>Heure de départ</mat-label>
          <input
            id="startTime"
            matInput
            type="time"
            matInput
            formControlName="startTime"
          />
        </mat-form-field>

        <fieldset class="fieldsetRecurrency">
          <legend>Récurrence</legend>
          <div class="recurrencySection">
            <mat-radio-group
              aria-label="Récurrence"
              class="recurrency-field"
              formControlName="recurrency"
            >
              <mat-radio-button
                *ngFor="let recurrency of recurrencies"
                [value]="recurrency.value"
                >{{ recurrency.name }}
              </mat-radio-button>
            </mat-radio-group>
          </div>

          <div
            *ngIf="editForm.value.recurrency === 'daily'"
            class="dailyRecurrency"
          >
            <mat-radio-group
              aria-label="Récurrence"
              class="dailyRecurrency-field"
              formControlName="dailyRecurrency"
            >
              <mat-radio-button *ngFor="let mode of daily" [value]="mode.value">
                {{ mode.name }}
              </mat-radio-button>
            </mat-radio-group>

            <mat-button-toggle-group
              *ngIf="editForm.value.dailyRecurrency === 'custom'"
              appearance="legacy"
              name="truc"
              aria-label="Font Style"
              multiple="true"
            >
              <mat-button-toggle
                *ngFor="let day of days"
                [value]="day"
                (change)="selectDay($event, day)"
              >
                {{ showDayText(day.value) | translate }}
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>

          <div
            *ngIf="editForm.value.recurrency === 'weekly'"
            class="weeklyRecurrency"
          >
            <p class="inputWeeklyRecurrency">
              Toutes les
              <input formControlName="weeklyRecurrency" type="number" />
              semaines
            </p>
            <mat-button-toggle-group
              appearance="legacy"
              name="fontStyle"
              aria-label="Font Style"
              multiple="true"
            >
              <mat-button-toggle
                *ngFor="let day of days"
                [value]="day"
                (change)="selectDay($event, day)"
              >
                {{ showDayText(day.value) | translate }}
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>

          <div
            *ngIf="editForm.value.recurrency === 'monthly'"
            class="monthlyRecurrency"
          >
            Le
            <input
              formControlName="dayMonthlyRecurrency"
              type="number"
              min="1"
              max="31"
              oninput="this.value =
              !!this.value && Math.abs(this.value) > 0 ? Math.abs(this.value) : null"
            />
            tous les mois
          </div>
        </fieldset>
      </fieldset>

      <fieldset *ngIf="isPonctualOrder">
        <legend>Dates de la commande ponctuelle</legend>

        <div class="ponctual-dates-section">
          <div class="date-time-group">
            <h3>Date et heure de création <span class="red">*</span></h3>
            <div class="date-time-fields">
              <mat-form-field class="date-field">
                <mat-label>Date de création</mat-label>
                <input
                  matInput
                  formControlName="scheduledDate"
                  color="primary"
                  [matDatepicker]="scheduledDatePicker"
                  (focus)="scheduledDatePicker.open()"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="scheduledDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #scheduledDatePicker></mat-datepicker>
                <mat-error>Date requise</mat-error>
              </mat-form-field>

              <mat-form-field class="time-field">
                <mat-label>Heure de création</mat-label>
                <input
                  matInput
                  type="time"
                  formControlName="scheduledTime"
                />
                <mat-error>Heure requise</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="date-time-group">
            <h3>Date et heure de départ <span class="red">*</span></h3>
            <div class="date-time-fields">
              <mat-form-field class="date-field">
                <mat-label>Date de départ</mat-label>
                <input
                  matInput
                  formControlName="orderStartDate"
                  color="primary"
                  [matDatepicker]="orderStartDatePicker"
                  (focus)="orderStartDatePicker.open()"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="orderStartDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #orderStartDatePicker></mat-datepicker>
                <mat-error>Date requise</mat-error>
              </mat-form-field>

              <mat-form-field class="time-field">
                <mat-label>Heure de départ</mat-label>
                <input
                  matInput
                  type="time"
                  formControlName="orderStartTime"
                />
                <mat-error>Heure requise</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </fieldset>

      <section style="padding: 20px 0px" *ngIf="!isPonctualOrder">
        <mat-slide-toggle formControlName="isActiveOnHolidays" color="primary">
          Activé les jours fériés
        </mat-slide-toggle>
      </section>

      <section>
        <h3>
          {{ "orders.create.orderType" | translate }}<span class="red">*</span>
        </h3>
        <mat-radio-group formControlName="type">
          <mat-radio-button value="isClient">Classique</mat-radio-button>
          <mat-radio-button value="isTour">Tournée</mat-radio-button>
        </mat-radio-group>
      </section>

      <section>
        <h3>
          {{ "orders.create.name.title" | translate }}
        </h3>
        <mat-form-field>
          <mat-label>{{ "orders.create.name.label" | translate }}</mat-label>
          <input type="text" matInput formControlName="name" />
          <mat-error>Maximum 50 caractères</mat-error>
        </mat-form-field>
      </section>

      <section *ngIf="isTour() && isControlSet('code')">
        <h3>
          {{ "orders.create.code.title" | translate }}
        </h3>
        <mat-form-field>
          <mat-label>{{ "orders.create.code.label" | translate }}</mat-label>
          <input
            type="text"
            matInput
            formControlName="code"
            [maxlength]="codeMaxLength"
          />
          <mat-error>
            {{ "orders.create.code.errorMessage" | translate }}
          </mat-error>
        </mat-form-field>
      </section>

      <section *ngIf="isTour()">
        <h3>{{ "orders.create.tourInfo" | translate }}</h3>
        <div class="tourInfoFields">
          <div>
            <app-autocomplete
              label="orders.create.driver"
              [control]="getControl('driver')"
              [list]="drivers"
            >
            </app-autocomplete>
          </div>

          <mat-form-field>
            <mat-label>{{ "orders.create.price" | translate }}</mat-label>
            <input type="number" min="0" matInput formControlName="price" />
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{
              "orders.create.extraStepPrice" | translate
            }}</mat-label>
            <input
              type="number"
              min="0"
              matInput
              formControlName="extraStepPrice"
            />
          </mat-form-field>
        </div>
      </section>

      <div class="ordererSiteSection">
        <section>
          <h3>
            Etablissement ({{ "orders.create.site.label" | translate }})
            <span class="red">*</span>
          </h3>
          <p *ngIf="!selectedClient && !isAdminWithOneClient" class="info-message">
            Veuillez d'abord sélectionner une agence ci-dessus
          </p>
          <app-autocomplete
            *ngIf="selectedClient || isAdminWithOneClient"
            [canString]="true"
            label="orders.create.site.label"
            class="site-field"
            [control]="getControl('site')"
            [list]="filteredSites"
            [setSites]="filteredSites"
            errorMsg="orders.create.site.errorMessage"
          >
          </app-autocomplete>
        </section>

        <section class="ordererSection">
          <h3>Demandeur</h3>
          <div class="ordererFields">
            <mat-form-field class="ordererName-field">
              <mat-label>{{
                "orders.create.ordererName.label" | translate
              }}</mat-label>
              <input matInput formControlName="ordererName" />
              <mat-error
                >{{ "orders.create.ordererName.errorMessage" | translate }}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="ordererPhone-field">
              <mat-label>{{
                "orders.create.ordererPhone.label" | translate
              }}</mat-label>
              <input matInput formControlName="ordererPhone" />
              <mat-error
                >{{ "orders.create.ordererPhone.errorMessage" | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        </section>
      </div>

      <fieldset formGroupName="sender" class="fieldsetSender">
        <legend *ngIf="!isTour()">
          Lieu d'enlèvement<span class="red">*</span>
        </legend>
        <legend *ngIf="isTour()">Étape 1<span class="red">*</span></legend>

        <section>
          <h3>Heure de passage souhaitée</h3>
          <mat-form-field class="creation-time-field" style="width: 100%">
            <input
              id="inputTime"
              matInput
              type="time"
              matInput
              formControlName="requestedTime"
            />
          </mat-form-field>
        </section>

        <section>
          <h3>Adresse <span class="red">*</span></h3>
          <app-autocomplete
            class="site-field"
            [control]="editForm.get('sender').get('address')"
            [list]="senders"
            [setSites]="senders"
            errorMsg="orders.create.sender.errorMessage"
            [canString]="canAddOtherAddress"
          >
          </app-autocomplete>
        </section>

        <section *ngIf="editForm.get('sender').get('address').value">
          <h3>
            {{ "orders.create.senderService.label" | translate }}
            <span class="red">*</span>
          </h3>

          <ng-container
            *ngIf="
              isTypeOf('string', editForm.get('sender').get('address').value);
              else noString
            "
          >
            <app-autocomplete-text
              class="site-field"
              [control]="editForm.get('sender').get('service')"
              [list]="[]"
              errorMsg="orders.create.senderService.errorMessage"
            >
            </app-autocomplete-text>
          </ng-container>

          <ng-template #noString>
            <app-autocomplete-text
              class="site-field"
              [control]="editForm.get('sender').get('service')"
              [list]="
                editForm.get('sender').get('address').value?.services?.sort()
              "
              errorMsg="orders.create.senderService.errorMessage"
            >
            </app-autocomplete-text>
          </ng-template>
        </section>

        <section>
          <h3>{{ "orders.create.ordererComment.title" | translate }}</h3>
          <mat-form-field class="comment-field">
            <textarea
              matInput
              rows="5"
              formControlName="ordererComment"
            ></textarea>
            <mat-error
              >{{ "orders.create.ordererComment.error" | translate }}
            </mat-error>
          </mat-form-field>
        </section>
      </fieldset>

      <section *ngIf="isControlSet('receivers')">
        <mat-list formArrayName="receivers">
          <mat-list-item
            class="oneReceiver"
            *ngFor="let control of getArray('receivers').controls; index as i"
            [formGroupName]="i"
          >
            <div matLine>
              <fieldset>
                <legend>
                  <span
                    *ngIf="
                      !isTour() && getArray('receivers').controls.length === 1
                    "
                    >Lieu du destinataire</span
                  >
                  <span
                    *ngIf="
                      isTour() || getArray('receivers').controls.length > 1
                    "
                  >
                    Étape
                    <span *ngIf="!isTour()"> {{ i + 1 }}</span>
                    <span *ngIf="isTour()"> {{ i + 2 }}</span>
                  </span>
                  <span *ngIf="i === 0" class="red">*</span>
                </legend>

                <section
                  *ngIf="
                    getControl('type').value !== 'isTour' &&
                    getArray('receivers').controls.length > 1
                  "
                >
                  <mat-radio-group formControlName="type">
                    <mat-radio-button value="isDelivery"
                      >Livraison</mat-radio-button
                    >
                    <mat-radio-button value="isPickup"
                      >Enlèvement</mat-radio-button
                    >
                  </mat-radio-group>
                </section>

                <section>
                  <h3>Heure de passage souhaitée</h3>
                  <mat-form-field class="creation-time-field">
                    <input
                      id="inputTime"
                      matInput
                      type="time"
                      matInput
                      formControlName="requestedTime"
                    />
                  </mat-form-field>
                </section>

                <section>
                  <h3>Adresse <span class="red">*</span></h3>
                  <app-autocomplete
                    class="site-field"
                    [control]="control.get('address')"
                    [list]="receivers"
                    [setSites]="receivers"
                    errorMsg="orders.create.receiver.errorMessage"
                    [canString]="canAddOtherAddress"
                  >
                  </app-autocomplete>
                </section>

                <section *ngIf="control.get('address').value">
                  <h3>
                    {{ "orders.create.receiverService.label" | translate }}
                    <span class="red">*</span>
                  </h3>

                  <ng-container
                    *ngIf="
                      isTypeOf('string', control.get('address').value);
                      else noString
                    "
                  >
                    <app-autocomplete-text
                      class="site-field"
                      [control]="control.get('service')"
                      [list]="[]"
                      errorMsg="orders.create.receiverService.errorMessage"
                    >
                    </app-autocomplete-text>
                  </ng-container>

                  <ng-template #noString>
                    <app-autocomplete-text
                      class="site-field"
                      [control]="control.get('service')"
                      [list]="control.get('address').value?.services"
                      errorMsg="orders.create.receiverService.errorMessage"
                    >
                    </app-autocomplete-text>
                  </ng-template>
                </section>

                <section>
                  <h3>
                    {{ "orders.create.ordererComment.title" | translate }}
                  </h3>
                  <mat-form-field class="comment-field">
                    <textarea
                      matInput
                      rows="5"
                      formControlName="ordererComment"
                    ></textarea>
                    <mat-error
                      >{{ "orders.create.ordererComment.error" | translate }}
                    </mat-error>
                  </mat-form-field>
                </section>
              </fieldset>
            </div>
            <button
              *ngIf="(isTour() && getArray('receivers').length > 1) || i !== 0"
              type="button"
              matTooltip="Retirer le destinataire"
              mat-icon-button
              color="primary"
              (click)="onRemoveReceiver(i)"
            >
              <mat-icon aria-label="delete">delete</mat-icon>
            </button>
          </mat-list-item>
          <mat-list-item
            *ngIf="!isClient && getArray('receivers').controls.length < 100"
          >
            <button
              type="button"
              mat-icon-button
              color="primary"
              matTooltip="Ajouter un destinataire"
              (click)="onAddReceiver()"
            >
              <mat-icon aria-label="Add">add</mat-icon>
            </button>
          </mat-list-item>
        </mat-list>
      </section>

      <section>
        <h3>
          {{ "orders.create.transportType.label" | translate }}
          <span class="red">*</span>
        </h3>

        <mat-form-field class="devicesChipList">
          <mat-chip-grid #chipList aria-label="Device selection">
            <mat-chip-row
              *ngFor="let selected of transportTypesSelected"
              [selectable]="selectable"
              [removable]="removable"
              (removed)="remove(selected)"
            >
              {{ selected.name }}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip-row>
            <input
              placeholder="Sélectionnez un type de produit"
              #deviceInput
              id="deviceChipList"
              [formControl]="transportTypesCtrl"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="addOnBlur"
              [matAutocomplete]="auto"
              [matChipInputFor]="chipList"
            />
            <button
              type="button"
              mat-icon-button
              color="primary"
              *ngIf="transportTypesSelected.length > 0"
              (click)="clearDevicesSelected()"
            >
              <mat-icon class="clearButton" (click)="clearDevicesSelected()"
                >clear</mat-icon
              >
            </button>
          </mat-chip-grid>
          <mat-autocomplete
            class="devicesDropdown"
            #auto="matAutocomplete"
            (optionSelected)="selected($event)"
          >
            <mat-option
              *ngFor="let device of filteredTransportTypes | async"
              [value]="device"
              [disabled]="device.selected"
            >
              {{ device.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </section>

      <section>
        <h3>
          {{ "orders.create.urgencyLevel" | translate }}
          <span class="red">*</span>
        </h3>
        <mat-radio-group
          aria-label="Sélectionnez un niveau d'urgence"
          class="urgency-field"
          formControlName="urgencyLevel"
        >
          <mat-radio-button
            *ngFor="let urgencyLevel of urgencyLevels"
            [value]="urgencyLevel"
            >{{ urgencyLevel.name }}
          </mat-radio-button>
        </mat-radio-group>
      </section>

      <section>
        <h3>Commentaires sur la course</h3>
        <mat-form-field class="comment-field">
          <textarea
            matInput
            rows="5"
            formControlName="ordererComment"
          ></textarea>
          <mat-error
            >{{ "orders.create.ordererComment.error" | translate }}
          </mat-error>
        </mat-form-field>
      </section>

      <section class="actions">
        <div
          class="checkButton"
          [matTooltip]="invalidMessage"
          [matTooltipDisabled]="
            editForm.valid &&
            transportTypesSelected.length !== 0 &&
            this.editForm.value.receivers[
              this.editForm.value.receivers.length - 1
            ].type !== 'isPickup'
          "
        >
          <button
            *ngIf="!isLoading"
            type="submit"
            mat-raised-button
            color="primary"
            [disabled]="
              editForm.invalid ||
              transportTypesSelected.length === 0 ||
              this.editForm.value.receivers[
                this.editForm.value.receivers.length - 1
              ].type === 'isPickup'
            "
          >
            {{ "global.validateAndCancel.validate" | translate }}
          </button>
        </div>

        <button
          *ngIf="!isLoading"
          type="button"
          mat-raised-button
          color="primary"
          (click)="onFinish()"
        >
          {{ "global.validateAndCancel.cancel" | translate }}
        </button>
        <mat-spinner
          *ngIf="isLoading"
          [diameter]="35"
          color="primary"
        ></mat-spinner>
      </section>
    </form>
  </mat-card-content>
</mat-card>
